import React, { lazy, Suspense } from 'react';
import { Route, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { VerticalAnimatedSwitch } from 'shared/animations';
import { withTranslation } from 'react-i18next';
import { QUOTEROUTES } from '../../shared/constants';
import Spinner from 'components/spinner/spinner';
import { useSelector } from 'react-redux';
import { cmsMap } from '../../services/cmsIdMap';
import * as ENV from '../../const';

const QuoteVehicleDetailsOption = lazy(() =>
    import('../../screens/quote/quoteVehicleDetailsOption')
);

const QuoteVehicleDetails = lazy(() => import('../../screens/quote/quoteVehicleDetails'));

const QuoteVehicleValue = lazy(() => import('../../screens/quote/quoteVehicleValue'));

const QuoteVehicleAdditionalInfo = lazy(() =>
    import('../../screens/quote/quoteVehicleAdditionalInfo')
);

const QuoteKnockout = lazy(() => import('../../screens/quote/quoteKnockout'));

const QuoteDriverDetailsOption = lazy(() => import('../../screens/quote/quoteDriverDetailsOption'));

const QuoteDriverDetails = lazy(() => import('../../screens/quote/quoteDriverDetails'));

const QuoteUaePassQRAuthentication = lazy(() => import('../../screens/quote/quoteUaePassQRAuthentication'));

const QuoteUaePassResponseFailure = lazy(() => import('../../screens/quote/quoteUaePassResponseFailure'));

const QuoteSummary = lazy(() => import('../../screens/quote/quoteSummary'));

const QuoteDriverContact = lazy(() => import('../../screens/quote/quoteDriverContactDetails'));

const QuoteCoverages = lazy(() => import('../../screens/quote/quoteCoverages'));

const QuoteDetailCoverage = lazy(() => import('../../screens/quote/quoteDetialsCoverage'));

const PolicyStartDate = lazy(() => import('../../screens/quote/PolicyStartDate/policyStartDate'));

const BuildingYourPolicy = lazy(() =>
    import('../../screens/quote/PolicyStartDate/buildingYourPolicy')
);

const RetrieveQuote = lazy(() => import('../../screens/quote/RetrieveQuote/retrieveQuote'));

const ConfirmPolicy = lazy(() => import('../../screens/quote/BindAndIssue/confirmPolicy'));

const RegulatoryField = lazy(() =>
    import('../../screens/quote/BindAndIssue/regulatoryFieldScreen')
);

const PayNowScreen = lazy(() => import('../../screens/quote/payment/payNowScreen'));

const PayNowPage = lazy(() => import('../../screens/quote/payment/payNowPage'));

const RosoomPaymentScreen = lazy(() => import('../../screens/quote/payment/rosoomPaymentScreen'));

const ProcessingPaymentScreen = lazy(() => import('../../screens/quote/payment/processingPayment'));

const ProcessingPaymentPage = lazy(() =>
    import('../../screens/quote/payment/processingPaymentPage')
);

const VerifyCustomerLogin = lazy(() =>
    import('../../screens/quote/offlineAccountLink/verifyCustomerLogin')
);

const UaepassThankYou = lazy(() => import('../../screens/quote/UaepassThankYou'));

const RequestCallBack = lazy(() => import('../../screens/quote/requestCallBack'));

const QuoteRoutes = ({ }) => {
    const pageContents = useSelector(
        (state) => state.cms.allPageContents[cmsMap.uaePassDocumentError]
    );
    const pageContentsDataShare = useSelector(
        (state) => state.cms.allPageContents[cmsMap.uaePassDocumentSharingReject]
    );
    const pageContentsDocumentFetch = useSelector(
        (state) => state.cms.allPageContents[cmsMap.uaePassDocumentFetchError]
    );

    const pageContentsAccountUpgrade = useSelector(
        (state) => state.cms.allPageContents[cmsMap.uaePassAccountUpgradeError]
    );
    const pageContentsButton = useSelector(
        (state) => state.cms.allPageContents[cmsMap.continuewithUAEPassScreen]
    );

    const pageContentsRequestCallBack = useSelector(
        (state) => state.cms.allPageContents[cmsMap.requestCallBack]
    );

    const pageContentsRequestCallBackThankYou = useSelector(
        (state) => state.cms.allPageContents[cmsMap.requestCallBackThankYou]
    );

    return (
        <VerticalAnimatedSwitch>
            <Route
                exact
                path={QUOTEROUTES.QUOTE}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteVehicleDetailsOption {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.VEHICLE_DETAILS}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteVehicleDetails {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.VEHICLE_VALUE}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteVehicleValue {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.VEHICLE_ADDITIONAL_INFO}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteVehicleAdditionalInfo {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.KNOCKOUT}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteKnockout {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.DRIVER_DETAILS_OPTION}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteDriverDetailsOption {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.DRIVER_DETAILS}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteDriverDetails {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.DRIVER_CONTACT}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteDriverContact {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.COVERAGES}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteCoverages {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.COVERAGE_DETAILS}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteDetailCoverage {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.RETREIVE_QUOTE}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <RetrieveQuote {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.POLICY_START_DATE}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <PolicyStartDate {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.BUILDING_YOUR_POLICY}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <BuildingYourPolicy {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.CONFIRM_POLICY}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <ConfirmPolicy {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.REQUESTCALLBACK}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <RequestCallBack
                            {...props}
                            heading1={pageContentsRequestCallBack?.heading1?.MainHeadingValue}
                            heading2={pageContentsRequestCallBack?.heading2?.MainHeadingValue}
                            subHeading1={
                                pageContentsRequestCallBack?.subheading1?.MainSubheadingValue
                            }
                            subHeading2={
                                pageContentsRequestCallBack?.subheading2?.MainSubheadingValue
                            }
                            imageUrl={`${ENV.CMS_BASE_IMAGE_URL}${pageContentsRequestCallBack?.errorImage?.image?.contentUrl}`}
                            buttonText={pageContentsRequestCallBack?.Submit?.MainSubheadingValue}
                            multipleSubheading="false"
                            mobileNumberNeeded="true"
                        />
                    </Suspense>
                )}
            />
            {/* <Route
                exact
                path="/quote/bindQuoteIssue"
                render={(props) =>(
                    <Suspense fallback={<Spinner/>}>
                    <BindQuoteIssue {...props} />
                    </Suspense>
                    )}
            /> */}

            <Route
                exact
                path={QUOTEROUTES.REQUESTCALLBACKTHANKYOU}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <RequestCallBack
                            {...props}
                            heading1={pageContentsRequestCallBackThankYou?.ThanksYouHeader}
                            heading2=""
                            subHeading1={pageContentsRequestCallBackThankYou?.CallBackRequestLabel}
                            subHeading2=""
                            imageUrl={`${ENV.CMS_BASE_IMAGE_URL}${pageContentsRequestCallBackThankYou?.CallCenterImage?.image?.contentUrl}`}
                            buttonText={pageContentsRequestCallBackThankYou?.BackToHomePageLabel}
                            multipleSubheading="false"
                            mobileNumberNeeded="false"
                        />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.BINDQUOTE_ISSUE}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <RegulatoryField {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.PAYNOW}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <PayNowScreen {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.PAYNOWAR}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <PayNowScreen {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.PAYNOWPAGE}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <PayNowPage {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.VERIFY_CUSTOMER}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <VerifyCustomerLogin {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.VERIFY_CUSTOMERAR}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <VerifyCustomerLogin {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.PAYMENT_GATEWAY}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <RosoomPaymentScreen {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.PROCESSING_PAYMENT}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <ProcessingPaymentScreen {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.PROCESSING_PAYMENTAR}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <ProcessingPaymentScreen {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.PROCESSING_PAYMENT_PAGE}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <ProcessingPaymentPage {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.UAE_PASS_QRCODE}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteUaePassQRAuthentication {...props} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.UAEPASS_RESPONSE_ERROR}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteUaePassResponseFailure
                            imageUrl={
                                pageContentsDocumentFetch?.errorImage &&
                                `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.errorImage?.image?.contentUrl}`
                            }
                            heading1={pageContentsDocumentFetch?.heading1?.MainHeadingValue}
                            heading2=""
                            subheading1={
                                pageContentsDocumentFetch?.subheading1?.MainSubheadingValue
                            }
                            subheading2={
                                pageContentsDocumentFetch?.subheading2?.MainSubheadingValue
                            }
                            subheading3=""
                            subheading4={
                                pageContentsDocumentFetch?.technical_issue?.MainSubheadingValue
                            }
                            subheading5={
                                pageContentsDocumentFetch?.request_call_back?.MainSubheadingValue
                            }
                            or={pageContentsDocumentFetch?.or?.MainSubheadingValue}
                            subheading6={
                                pageContentsDocumentFetch?.call_directly?.MainSubheadingValue
                            }
                            subheading7={pageContentsDocumentFetch?.hyperlink?.MainSubheadingValue}
                            subheading8={
                                pageContentsDocumentFetch?.pancutation?.MainSubheadingValue
                            }
                            subheading10={pageContentsButton?.["Please Retry Label"].Value}
                            />

                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.UAEPASS_RESPONSE_REJECT_ERROR}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteUaePassResponseFailure
                            imageUrl={
                                pageContentsDataShare?.errorImage &&
                                `${ENV.CMS_BASE_IMAGE_URL}${pageContentsDataShare?.errorImage?.image?.contentUrl}`
                            }
                            heading1={pageContentsDataShare?.heading1?.MainHeadingValue}
                            heading2=""
                            subheading1={pageContentsDataShare?.subheading1?.MainSubheadingValue}
                            subheading2={pageContentsDataShare?.subheading2?.MainSubheadingValue}
                            subheading3=""
                            subheading4={
                                pageContentsDataShare?.technical_issue?.MainSubheadingValue
                            }
                            subheading10={pageContentsButton?.["Please Retry Label"].Value}
                            subheading5={pageContentsDataShare?.call_back?.MainSubheadingValue}
                            or={pageContentsDataShare?.or?.MainSubheadingValue}
                            subheading6={pageContentsDataShare?.call_directly?.MainSubheadingValue}
                            subheading7={pageContentsDataShare?.hyperlink?.MainSubheadingValue}
                            subheading8={pageContentsDataShare?.puncation?.MainSubheadingValue} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.UAEPASS_RESPONSE_EXITED_ERROR}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteUaePassResponseFailure
                            imageUrl={
                                pageContentsDataShare?.errorImage &&
                                `${ENV.CMS_BASE_IMAGE_URL}${pageContentsDataShare?.errorImage?.image?.contentUrl}`
                            }
                            heading1={pageContentsDataShare?.heading1?.MainHeadingValue}
                            heading2=""
                            subheading1={pageContentsDataShare?.subheading4?.MainSubheadingValue}
                            subheading2={pageContentsDataShare?.subheading2?.MainSubheadingValue}
                            subheading3=""
                            subheading4={
                                pageContentsDataShare?.technical_issue?.MainSubheadingValue
                            }
                            subheading10={pageContentsButton?.["Please Retry Label"].Value}
                            subheading5={pageContentsDataShare?.call_back?.MainSubheadingValue}
                            or={pageContentsDataShare?.or?.MainSubheadingValue}
                            subheading6={pageContentsDataShare?.call_directly?.MainSubheadingValue}
                            subheading7={pageContentsDataShare?.hyperlink?.MainSubheadingValue}
                            subheading8={pageContentsDataShare?.puncation?.MainSubheadingValue} />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.UAEPASS_ACCOUNT_NOT_QUALIFIED_ERROR}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteUaePassResponseFailure
                            imageUrl={
                                pageContents?.errorImage &&
                                `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.errorImage?.image?.contentUrl}`
                            }
                            heading1={pageContents?.heading1?.MainHeadingValue}
                            heading2={pageContents?.heading2?.MainHeadingValue}
                            subheading1={pageContents?.subheading1?.MainSubheadingValue}
                            subheading2={pageContents?.subheading2?.MainSubheadingValue}
                            subheading3={pageContents?.subheading3?.MainSubheadingValue}
                            subheading4={pageContents?.subheading4?.MainSubheadingValue}
                            subheading5={pageContents?.subheading5?.MainSubheadingValue}
                            or={pageContents?.subheading6?.MainSubheadingValue}
                            subheading6={pageContents?.subheading7?.MainSubheadingValue}
                            subheading7={pageContents?.subheading8?.MainSubheadingValue}
                            subheading9={pageContents?.subheading9?.MainSubheadingValue}
                        />
                    </Suspense>
                )}
            />
            <Route
                exact
                path={QUOTEROUTES.UAEPASS_UPGRADE_ACCOUNT_ERROR}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteUaePassResponseFailure
                            imageUrl={
                                pageContentsAccountUpgrade?.errorImage &&
                                `${ENV.CMS_BASE_IMAGE_URL}${pageContents?.errorImage?.image?.contentUrl}`
                            }
                            heading1={pageContentsAccountUpgrade?.heading1?.MainHeadingValue}
                            heading2=""
                            subheading1={
                                pageContentsAccountUpgrade?.subheading1?.MainSubheadingValue
                            }
                            subheading2={
                                pageContentsAccountUpgrade?.subheading2?.MainSubheadingValue
                            }
                            subheading3=""
                            subheading4={
                                pageContentsAccountUpgrade?.technical_issues?.MainSubheadingValue
                            }
                            subheading5={pageContentsAccountUpgrade?.call_back?.MainSubheadingValue}
                            or={pageContentsAccountUpgrade?.or?.MainSubheadingValue}
                            subheading6={
                                pageContentsAccountUpgrade?.call_directly?.MainSubheadingValue
                            }
                            subheading7={pageContentsAccountUpgrade?.hyperlink?.MainSubheadingValue}
                            subheading8={
                                pageContentsAccountUpgrade?.punctution?.MainSubheadingValue
                            } />
                    </Suspense>
                )}
            />
            <Route
                path={QUOTEROUTES.POLICY_SUMMARY}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <QuoteSummary {...props} />
                    </Suspense>
                )}
            />
            <Route
                path={QUOTEROUTES.UAEPASS_THANKYOU}
                render={(props) => (
                    <Suspense fallback={<Spinner />}>
                        <UaepassThankYou {...props} />
                    </Suspense>
                )}
            />
        </VerticalAnimatedSwitch>
    );
};

export default withTranslation()(withRouter(connect()(QuoteRoutes)));
